import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  @Select((state:any) => state.global.logoSrc) logo$!: Observable<string>;
  constructor() { }

  ngOnInit(): void {
  }

}
